export const getHotSettings = (config) => {
	let settings = 
	{
		// data source
    data: config.list,

    // row settings
    rowHeaders: config.editMode,
    allowInsertRow: true,
    allowRemoveRow: true,
    viewportRowRenderingOffset: 120,

    // column settings
    colHeaders: config.editMode,
    allowInsertColumn: false,
    allowRemoveColumn: false,
    stretchH: 'all',

    // cell settings
    cells: config.spreadsheetRenderer,
    mergeCells: config.mergeRanges,

    // table settings
    contextMenu: config.editMode,
    className: 'htMiddle htCenter',
		height: '100%',
    readOnly: !config.editMode,
    
    // licensing
    licenseKey: 'non-commercial-and-evaluation',
  }
  
  let filterSettings = config.filters ? 
	{
    filters: true,
    dropdownMenu: ['filter_by_value', 'filter_action_bar'],
	}
	: {}

  Object.assign(settings, filterSettings)
	return settings
}
